import React, {useState} from "react";
import {notifyUser} from "../../../util/util";
import {serverRequest} from "../../../util/server_request";
import { useLocation, useNavigate } from 'react-router-dom';
import {Spin} from "antd";
import secureLocalStorage from "react-secure-storage";

export const CreatePassword = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const email = location.state?.email;
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false)
    const [passwordType, setPasswordType] = useState('password')
    const togglePasswordType = () => {
        if(passwordType === 'password'){
            setPasswordType('text')
        }else{
            setPasswordType('password')
        }
    }

    const toggleLoading = () => setLoading(prevState => !prevState)

    const criteria = {
        minLength: password.length >= 8,
        hasUppercase: /[A-Z]/.test(password),
        hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        hasNumber: /\d/.test(password),
    };

    const createPassword = () => {
        const isValid = Object.values(criteria).every(Boolean);

        if (isValid) {
            if (password !== confirmPassword){
                notifyUser('error', 'Password must match password confirmation', 'Validation Error')
                return
            }

            toggleLoading()
            
            // Get employerNumber from storage if available
            const employerNumber = secureLocalStorage.getItem('employerNumber')
            
            const payload = { password, confirmPassword, email }
            // Include employerNumber in body if available
            if (employerNumber) {
                payload.employerNumber = employerNumber
            }
            
            serverRequest('POST', 'auth/password/set-up', payload)
                .then(result => {
                    toggleLoading()
                    if (result?.success){
                        secureLocalStorage.setItem('token', result?.data.authToken)
                        secureLocalStorage.setItem('expiresAt', result?.data.expiresAt)
                        secureLocalStorage.setItem('user', JSON.stringify(result?.data.user));
                        navigate('/onboard/pin-setup')
                    }
                }).catch(error => {
                toggleLoading()
                notifyUser('error', error, 'Error')
            })

        }else{
            notifyUser('error', 'Password must match all requirement', 'Validation Error')
        }
    }

    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Create your password</p>
                <small className='text-center'>Create a strong & secure password to ensure your account is safe online.</small>
                <Spin spinning={loading}>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <omk-text-field  label="Password" value={password} type={passwordType} class='mb-4' onInput={e => setPassword(e.target.value)} name='password'>
                            <omk-icon slot="trailing-icon" onClick={togglePasswordType} style={{ cursor: 'pointer'}}><i className="bi bi-eye-slash"/></omk-icon>
                        </omk-text-field>
                        <div>
                            <div className="row mb-4">
                                <div className="col-6">
                                    <small
                                        className={criteria.minLength ? 'text-success float-start' : 'omk-text-secondary float-start'}><i
                                        className="bi bi-check-lg"/> Min 8 characters</small><br/>
                                    <small
                                        className={criteria.hasUppercase ? 'text-success float-start' : 'omk-text-secondary float-start'}><i
                                        className="bi bi-check-lg"/> An uppercase</small>
                                </div>
                                <div className="col-6">
                                    <small
                                        className={criteria.hasSpecialChar ? 'text-success float-start' : 'omk-text-secondary float-start'}><i
                                        className="bi bi-check-lg"/> A special character</small><br/>
                                    <small
                                        className={criteria.hasNumber ? 'text-success float-start' : 'omk-text-secondary float-start'}><i
                                        className="bi bi-check-lg"/> A number</small>
                                </div>
                            </div>
                        </div>
                        <omk-text-field label="Confirm Password" value={confirmPassword} type={passwordType} className='mb-5'
                                        name='confirmPassword' onInput={e => setConfirmPassword(e.target.value)}/>
                        <p className="text-center omk-text-small fw-bold">Need help?</p>
                        <p className="text-center omk-text-small text-black-50"><i className="bi bi-shield-lock"/> Your
                            information is confidential and secure</p>

                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={createPassword}>Continue</button>
                    </div>
                </Spin>
            </div>
        </div>
    )
}